import PendoScript from '@components/PendoScript';
import DatadogInit from '@utils/datadog-rum';
import { AppProps } from 'next/app';
import localFont from 'next/font/local';
import Head from 'next/head';

import '@bice_vida/ds-theme/onboarding';
import '@src/i18n';

import '@BICE_Vida/components/dist/main.css';
import '@BICE_Vida/tsp-components/dist/index.css';
import './styles.scss';

const materialIcons = localFont({
  src: [
    {
      path: '../../public/fonts/Material-Round.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
  display: 'swap',
});

const poppins = localFont({
  src: [
    {
      path: '../../public/fonts/Poppins-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/Poppins-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/fonts/Poppins-SemiBold.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../../public/fonts/Poppins-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/fonts/Poppins-ExtraBold.woff2',
      weight: '800',
      style: 'extra-bold',
    },
  ],
  display: 'swap',
});

function CustomApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>Seguro de Deceso | BICE VIDA</title>
      </Head>
      <main className="app">
        <style jsx global>
          {`
            :root {
              --poppins-font: ${poppins.style.fontFamily};
              --font-family-base: ${poppins.style.fontFamily};
              --font-family-material-icons-round: ${materialIcons.style.fontFamily};
              --material-icons-round-font: ${materialIcons.style.fontFamily};
            }
          `}
        </style>
        <PendoScript />
        <DatadogInit />
        <Component {...pageProps} />
      </main>
    </>
  );
}

export default CustomApp;
